"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serialization_error_1 = require("./errors/serialization_error");
const METADATA_KEY = Symbol('Metadata containing info about serializable object');
/** Metadata container for serializables */
class Metadata {
    constructor() {
        this.props = new Map();
    } // constructable via `getOrCreateFor`
    /** Get metadata for given object if it's exists or create an empty metadata container */
    static getOrCreateFor(target) {
        let metadata = this.getFor(target);
        if (!metadata) {
            metadata = new Metadata();
            Reflect.defineMetadata(METADATA_KEY, metadata, target);
        }
        return metadata;
    }
    /** Get metadata for given object if it's exists or return a null */
    static getFor(target) {
        if (target === null || target === undefined) {
            throw new serialization_error_1.default('null/undefined can not be serializable');
        }
        const metadata = Reflect.getOwnMetadata(METADATA_KEY, target) || null;
        return metadata;
    }
    /** Get metadata for given object if it's exists or throw an error */
    static expectFor(target) {
        let metadata = this.getFor(target);
        if (!metadata) {
            throw new serialization_error_1.default("Provided type doesn't seem to be serializable. Hint: use `serialize` decorator to mark properties for serialization");
        }
        return metadata;
    }
}
exports.default = Metadata;
//# sourceMappingURL=metadata.js.map